export const vitrinsFilters = {
  group: ['organization'],
  groupLimit: 5,
  sortProperty: 'advertising.position',
  sortDirection: 'asc',
  organizations: '',
};
